import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const LegalitiesPolicy = () => {
  const navigate = useNavigate();

  const handleBackRegister = () => {
    navigate("/register");
  };
  return (
    <React.Fragment>
      <Box sx={{ padding: "0px", margin: "0 auto" }}>
        <Typography
          variant="h4"
          gutterBottom
          fontSize={{ xs: "20.76px", md: "28px" }}
          fontWeight={{ xs: "600", md: "500" }}
          color={"#000000"}
        >
          Legalities and Policies
        </Typography>

        <Box
          sx={{
            maxHeight: "65vh",
            overflow: "auto",
            paddingRight: "10px",
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#233F91",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
            },
          }}
        >
          <Box mt={3} sx={{ marginBottom: "20px" }}>
            <Typography
              variant="h5"
              gutterBottom
              fontWeight={700}
              fontSize={"18px"}
            >
              Terms of Service
            </Typography>
            <Typography
              color={"#6D6D6D"}
              paragraph
              mt={2}
              fontWeight={400}
              fontSize={"16px"}
              lineHeight={"19.36px"}
            >
              SLorem ipsum dolor sit amet consectetur. Senectus consectetur
              ipsum lobortis lectus volutpat. Mus montes amet pellentesque
              sagittis dolor a id vel augue. Scelerisque neque enim elit duis
              massa volutpat quam vulputate sit. Sollicitudin lectus lectus
              auctor hendrerit posuere lacus. Metus habitasse dui amet ut morbi
              augue. Gravida sodales in pulvinar a pulvinar vulputate commodo
              vulputate risus. Morbi massa dolor molestie morbi arcu pharetra ut
              nunc. Cras fringilla lectus urna sagittis ac laoreet nunc morbi.
              Elementum cursus euismod morbi condimentum ultricies vel sed non
              sed. Ut ipsum dictum sollicitudin vel libero nisl massa commodo
              volutpat. A faucibus a commodo aliquam mi eleifend pharetra
              ornare.
            </Typography>
            <Typography
              lineHeight={"19.36px"}
              color={"#6D6D6D"}
              paragraph
              fontWeight={400}
              fontSize={"16px"}
            >
              Cras lorem ornare semper mi a sit velit. Dignissim leo eget
              egestas sit. In integer egestas egestas vulputate. Nullam
              dignissim at malesuada venenatis netus tristique mattis
              ullamcorper eu. Justo eget vulputate cras nulla nisl id. Sagittis
              sit pulvinar tincidunt ut sed. Eget vitae aliquam cras lorem eget
              aliquam maecenas aliquam. Sagittis tristique aliquet massa nullam
              lacus auctor gravida. Pharetra sed ut volutpat eget proin. Felis
              adipiscing velit turpis amet. Tellus eu amet velit non dolor
              pulvinar tempus.{" "}
            </Typography>
          </Box>

          <Box sx={{ marginBottom: "20px" }}>
            <Typography
              variant="h5"
              gutterBottom
              fontWeight={700}
              fontSize={"18px"}
            >
              Privacy Policy
            </Typography>
            <Typography
              lineHeight={"19.36px"}
              color={"#6D6D6D"}
              mt={2}
              paragraph
              fontWeight={400}
              fontSize={"16px"}
            >
              SLorem ipsum dolor sit amet consectetur. Senectus consectetur
              ipsum lobortis lectus volutpat. Mus montes amet pellentesque
              sagittis dolor a id vel augue. Scelerisque neque enim elit duis
              massa volutpat quam vulputate sit. Sollicitudin lectus lectus
              auctor hendrerit posuere lacus. Metus habitasse dui amet ut morbi
              augue. Gravida sodales in pulvinar a pulvinar vulputate commodo
              vulputate risus. Morbi massa dolor molestie morbi arcu pharetra ut
              nunc. Cras fringilla{" "}
            </Typography>
          </Box>
        </Box>

        {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}> */}
        <Grid item xs={12} mt={3} ml={2}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            onClick={handleBackRegister}
            sx={{
              // marginTop: '20px',
              width: "90%",
              backgroundColor: "#233F91",
              color: "#fff",
              textTransform: "none",
              borderRadius: "12px",
              height: "48px",
              margin: "0 auto",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            Back to Registration
          </Button>
        </Grid>
        {/* </Box> */}
      </Box>
    </React.Fragment>
  );
};

export default LegalitiesPolicy;
